import { observer } from '@legendapp/state/react';
import { Box, Burger, Center, Group, Menu, Switch } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { modals } from '@mantine/modals';
import { SpeakerHighIcon } from '@phosphor-icons/react/dist/ssr';
import { useTranslation } from 'react-i18next';
import { uiState$ } from '../../state/ui.state';

export const SettingsButton = observer(() => {
  const [opened, { open, close }] = useDisclosure();
  const { t } = useTranslation();

  const openHowtoPlayModal = () => {
    close();
    modals.openContextModal({
      modal: 'howToPlay',
      title: t('howToPlayModal.title'),
      size: 'xl',
      innerProps: {},
      centered: true,
    });
  };

  const openGameLimitsModal = () => {
    close();
    modals.openContextModal({
      modal: 'gameLimits',
      title: t('gameLimitsModal.title'),
      innerProps: {},
      centered: true,
    });
  };

  return (
    <Box data-test-id="desktop-burger-menu-container">
      <Menu
        closeOnItemClick={false}
        data-test-id="desktop-burger-menu"
        offset={8}
        onClose={close}
        opened={opened}
        position="bottom-end"
        shadow="md"
        width={240}
      >
        <Menu.Target>
          <Center
            bg={{
              base: 'rgba(41, 41, 51, 0.8)',
              xl: 'rgba(41, 41, 51, 0.50)',
            }}
            h={30}
            style={{
              borderRadius: 8,
            }}
            w={30}
          >
            <Burger
              aria-label={t('settingsMenu.toggleNavigation')}
              color="white"
              data-test-id="desktop-burger-button"
              lineSize={2}
              onClick={open}
              opened={opened}
              size={16}
            />
          </Center>
        </Menu.Target>

        <Menu.Dropdown data-test-id="desktop-burger-dropdown">
          <Menu.Item data-test-id="desktop-sound-toggle-item">
            <Group justify="space-between">
              <Group gap={10}>
                <SpeakerHighIcon size={20} weight="fill" />
                {t('settingsMenu.sound')}
              </Group>
              <Switch
                checked={uiState$.soundTurnedOn.get()}
                data-test-id="desktop-sound-toggle"
                onChange={(v) =>
                  uiState$.soundTurnedOn.set(v.currentTarget.checked)
                }
              />
            </Group>
          </Menu.Item>
          <Menu.Divider />
          <Menu.Item
            data-test-id="desktop-game-rules-item"
            onClick={openHowtoPlayModal}
          >
            {t('settingsMenu.howToPlay')}
          </Menu.Item>
          <Menu.Divider />
          <Menu.Item
            data-test-id="desktop-game-limits-item"
            onClick={openGameLimitsModal}
          >
            {t('settingsMenu.gameLimits')}
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Box>
  );
});
